/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SingleEditorDto } from '../../models/single-editor-dto';

export interface EditorGetByMenuId$Json$Params {
  menuId: string;
}

export function editorGetByMenuId$Json(http: HttpClient, rootUrl: string, params: EditorGetByMenuId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SingleEditorDto>>> {
  const rb = new RequestBuilder(rootUrl, editorGetByMenuId$Json.PATH, 'get');
  if (params) {
    rb.path('menuId', params.menuId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SingleEditorDto>>;
    })
  );
}

editorGetByMenuId$Json.PATH = '/api/Editor/{menuId}';
